import appStyles from '@/App.scss?url';
import { loadEnvForStage } from '@/utils/load-env.server';
import { getEnv, initEnv } from '@/utils/env';
import type { FeatureFlagMap } from '@/store/slices/feature-flags/types';

export async function loader() {
  const stage = process.env.STAGE ?? 'dev';
  const env = loadEnvForStage(stage);
  initEnv(env);

  let featureFlags: FeatureFlagMap = {};
  const res = await fetch(`${process.env.EVENTS_API_HOST}/v3/feature-flags`);

  if (res.ok) {
    featureFlags = (await res.json()) as FeatureFlagMap;
  }

  return { env, featureFlags };
}

// Client-side env middleware
const envClientMiddleware = async () => {
  let env = getEnv();
  // if the env is not set, try to get it from the server
  // Make sure that it's not an object with empty values
  if (!env || !env.VITE_STAGE) {
    env = await fetch('/api/get-env').then((res) => res.json());
    initEnv(env);
  }
};

export const clientMiddleware = [envClientMiddleware];

export const links = () => [{ rel: 'stylesheet', href: appStyles }];
export { default } from '@/App';
export { default as ErrorBoundary } from '@/pages/error';
